/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type SexAtBirth = (typeof SexAtBirth)[keyof typeof SexAtBirth];

export const SexAtBirth = {
  M: "M",
  F: "F",
  I: "I",
  UNK: "UNK",
} as const;
